import styled from "styled-components"
//import media from "styled-media-query"

export const SearchBox = styled.div`
  /* background-color: ${props => props.theme.colors.trueWhite}; */
  height: auto;
  width: 100%;

  h3 {
    margin-bottom: 0.5em;
  }
`
export const SearchForm = styled.form`
  display: flex;
`

export const SearchInput = styled.input`
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 0.5em;
  font-size: ${props => props.theme.fontSizes.small};
  flex-basis: 99%;
  height: 2em;
  margin-right: 0.2em;
  outline: 0;
  padding: 1.5em 0 1.5em 1em;
  width: 100%;
`
